'use strict';

exports.__esModule = true;

var _container = require('../container');

var _container2 = _interopRequireDefault(_container);

var _onFulfillment = require('../utils/onFulfillment');

var _onFulfillment2 = _interopRequireDefault(_onFulfillment);

var _onRejection = require('../utils/onRejection');

var _onRejection2 = _interopRequireDefault(_onRejection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchRequest = function fetchRequest(store, next, action) {
  var req = _container2.default.getDefinition('requestBuilder').getArgument('build')(action.request.url, {
    method: action.method,
    body: action.request.body,
    headers: action.request.headers
  });
  var meta = action.request.meta || {};

  return fetch(req).then(function (response) {
    meta.response = response;
    return response;
  }).then(_container2.default.getUtil('handleResponse')).then((0, _onFulfillment2.default)(store, next, action, meta), (0, _onRejection2.default)(store, next, action, meta));
};

exports.default = fetchRequest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/middleware/fetchRequest.js
// module id = 344
// module chunks = 0